import React from 'react';
import './ImpersonationBanner.css';

/**
 * Banner shown at top when platform owner is impersonating a user
 */
export default function ImpersonationBanner({ impersonationData, onExit }) {
  if (!impersonationData) return null;

  const impersonatedAtTime = new Date(impersonationData.impersonatedAt).toLocaleTimeString();

  return (
    <div className="impersonation-banner">
      <div className="impersonation-banner-content">
        <span className="impersonation-icon">👤</span>
        <div className="impersonation-text">
          <strong>Impersonating: {impersonationData.currentUser.name}</strong>
          <span className="impersonation-detail">
            {impersonationData.currentUser.email} • Started at {impersonatedAtTime}
          </span>
        </div>
      </div>
      <button
        className="impersonation-exit-btn"
        onClick={onExit}
        title="Exit impersonation and return to your account"
      >
        Exit Impersonation
      </button>
    </div>
  );
}
